<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (isSpinner) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

<!-- Dashboard-handoff banner. Visible only when the page was opened from a
     dashboard cell with locationId / listingStatus pre-applied. "Clear
     filters" button on the right side of the table already exists; the user
     can also click that to reset to the default unfiltered view. -->
<div *ngIf="inheritedFilterSummary" class="inherited-filter-banner"
     style="margin: 8px 12px 0; padding: 8px 12px; background:#EFF6FF; border:1px solid #3B82F6; border-radius:4px; font-size:12px; color:#1E3A8A;">
  <strong>Filtered from Operations Dashboard</strong> — {{ inheritedFilterSummary }}
</div>

<p-table #pt [value]="properties" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25, 200, 400, 1000, 2500]" [lazy]="true"
  (onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple" [columns]="columns"
  selectionMode="single" [(selection)]="property" dataKey="shortTermRentalId" (onRowSelect)="onRowSelect($event)"
  showCurrentPageReport="true" currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  [loading]="loading" styleClass="property-list-table p-datatable-striped" [ngStyle]="{'width': 'auto'}">
  <ng-template pTemplate="caption">
    <div class="d-flex text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Properties</h1>
      <div class="notes">
        <span>Notes: Please press the Enter key after typing into the filter to apply the results.</span>
      </div>
      <span>
        <!--clear filters-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="openPublicTaskList()">Tasks</button>
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px; margin-top: 0px !important;"
        (click)="reloadPage()">Clear Filters</button>

        <!--add new-->
        <button pButton pRipple class="p-button" routerLink="/property-add" style="padding: 0.643rem 0.75rem !important; margin-top: 0px !important;">New Property +</button>

        <app-import-export importEnabled="false" [dataRetrived]="properties" (exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true"></app-import-export>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'shortTermRentalId'">
        <p-sortIcon [field]="'shortTermRentalId'"></p-sortIcon>Id
      </th>
      <th [pSortableColumn]="'listingStatus'">
        <p-sortIcon [field]="'listingStatus'"></p-sortIcon>Status
      </th>
      <th [pSortableColumn]="'locationId'">
        <p-sortIcon [field]="'locationId'"></p-sortIcon>Location
      </th>
      <th [pSortableColumn]="'addressRegion'">
        <p-sortIcon [field]="'addressRegion'"></p-sortIcon>Region
      </th>
      <th [pSortableColumn]="'addressDistrictName'">
        <p-sortIcon [field]="'addressDistrictName'"></p-sortIcon>District
      </th>
      <th [pSortableColumn]="'addressCounty'">
        <p-sortIcon [field]="'addressCounty'"></p-sortIcon>County
      </th>
      <th [pSortableColumn]="'propertyCode'">
        <p-sortIcon [field]="'propertyCode'"></p-sortIcon>Property
      </th>
      <th [pSortableColumn]="'addressUnit'">
        <p-sortIcon [field]="'addressUnit'"></p-sortIcon>Unit
      </th>
      <th [pSortableColumn]="'developmentVO.addressDevelopmentName'">
        <p-sortIcon [field]="'developmentVO.addressDevelopmentName'"></p-sortIcon>Development
      </th>
      <th [pSortableColumn]="'bedrooms'">
        <p-sortIcon [field]="'bedrooms'"></p-sortIcon>Beds
      </th>
      <th [pSortableColumn]="'bathrooms'">
        <p-sortIcon [field]="'bathrooms'"></p-sortIcon>Baths
      </th>
      <th [pSortableColumn]="'addressStreetName'">
        <p-sortIcon [field]="'addressStreetName'"></p-sortIcon>Address
      </th>

      <th [pSortableColumn]="'rentalTaxIdNumber'">
        <p-sortIcon [field]="'rentalTaxIdNumber'"></p-sortIcon>TAT
      </th>
      <th [pSortableColumn]="'vrboListingNumber'">
        <p-sortIcon [field]="'vrboListingNumber'"></p-sortIcon>VRBO
      </th>
      <th [pSortableColumn]="'ruPropertyId'">
        <p-sortIcon [field]="'ruPropertyId'"></p-sortIcon>RU
      </th>
      <th [pSortableColumn]="'slPropertyId'">
        <p-sortIcon [field]="'slPropertyId'"></p-sortIcon>SL PropertyId
      </th>
      <th [pSortableColumn]="'matterportListingNumber'">
        <p-sortIcon [field]="'matterportListingNumber'"></p-sortIcon>Matterport
      </th>
      <th [pSortableColumn]="'listingType'">
        <p-sortIcon [field]="'listingType'"></p-sortIcon>Listing Type
      </th>
      <th [pSortableColumn]="'sitePriority'">
        <p-sortIcon [field]="'sitePriority'"></p-sortIcon>Site Priority
      </th>
      <th> Action
      </th>



    </tr>


		<tr>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="number"
					(keydown.enter)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
			<th>
				<p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [(ngModel)]="listingStatusObj" [options]="listingStatuses" appendTo="body"
					(onChange)="pt.filter($event.value, 'listingStatus', 'in')" styleClass="p-column-filter"
					placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
					<ng-template let-option pTemplate="item">
						<span>{{option.name}}</span>
					</ng-template>
				</p-dropdown>
			</th>
			<th>
				<p-dropdown [style]="{'width':'50px','min-width':'100%'}" [options]="locations" appendTo="body"
					(onChange)="pt.filter($event.value, 'locationId', 'in')" styleClass="p-column-filter"
					placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="locationId"
					[value]="pt.filters['locationId'] ? pt.filters['locationId'].value : ''">
					<ng-template let-option pTemplate="item">
						<span>{{option.name}}</span>
					</ng-template>
				</p-dropdown>
			</th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
				(keydown.enter)="pt.filter($event.target.value, 'addressRegion', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
				(keydown.enter)="pt.filter($event.target.value, 'addressDistrictName', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
				(keydown.enter)="pt.filter($event.target.value, 'addressCounty', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'propertyCode', 'in')"
					[value]="pt.filters['propertyCode'] ? pt.filters['propertyCode'].value : ''"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'addressUnit', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:100px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'developmentVO.addressDevelopmentName', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:50px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'bedrooms', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:50px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'bathrooms', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:50px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'addressStreetName', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:50px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'rentalTaxIdNumber', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:50px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'vrboListingNumber', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:50px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'ruPropertyId', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:50px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'slPropertyId', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText style="width:50px;" type="text"
					(keydown.enter)="pt.filter($event.target.value, 'matterportListingNumber', 'in')"></th>
					<th>
						<p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="listingTypes" appendTo="body"
							(onChange)="pt.filter($event.value, 'listingType', 'in')" styleClass="p-column-filter"
							placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
							<ng-template let-option pTemplate="item">
								<span>{{option.name}}</span>
							</ng-template>
						</p-dropdown>
					</th>
			<th>
				<p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="sitePriorities" appendTo="body"
					(onChange)="pt.filter($event.value, 'sitePriority', 'in')" styleClass="p-column-filter" placeholder="Filter"
					[showClear]="true" optionLabel="name" optionValue="value">
					<ng-template let-option pTemplate="item">
						<span>{{option.name}}</span>
					</ng-template>
				</p-dropdown>
			</th>
			<th [ngStyle]="{'width': 'auto'}"></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-property>
		<tr>
			<td><a href="/property-edit/{{property.shortTermRentalId}}" target="_blank">
					<i class="pi pi-pencil" aria-hidden="true"
						style="color:blue; font-size:110%; padding-right:20px;"></i>&nbsp;&nbsp;{{property.shortTermRentalId}}
				</a></td>
			<td>{{ListingStatus[property['listingStatus']] }}</td>
			<td>{{Locations[property['locationId']] }}</td>
			<td>{{property?.adrRegion}}</td>
			<td>{{property?.adrDistrictName}}</td>
			<td>{{property?.adrCounty}}</td>
			<td><a href="/property-edit/{{property.shortTermRentalId}}" target="_blank">{{property.propertyCode}}</a>
			</td>
			<td>{{property.adrUnit}}</td>
			<td>{{property.developmentName}}</td>
			<td>{{property.bedroomNum}}</td>
			<td>{{property.bathroomNum}}</td>
			<td>{{property?.adrStreetNumber}} {{property?.adrStreetName}} {{property?.adrBuildingName}}
				{{property?.adrCity}}, {{property?.adrState}} {{property?.adrIsland}} {{property?.adrDistrictName}}
				{{property?.adrRegion}}</td>
			<td>{{property.taxId}}</td>
			<td>
				<a href="https://www.vrbo.com/{{property.vrboId}}" target="_blank">
					{{property.vrboId}}
				</a>
			</td>
			<td><a href="https://new.rentalsunited.com/MyProperties/Edit/{{property.ruPropertyId}}" target="_blank">
					{{property.ruPropertyId}}
				</a>
			</td>
			<td>{{property.slPropertyId}}
			</td>
			<td>
				<a href="https://my.matterport.com/models/{{property.matterportId}}" target="_blank">
					{{property.matterportId}}
				</a>
			</td>
			<td>{{getListingTypeName(property.listingType)}}</td>
			<!-- <td>{{property.sitePriority}}</td> -->
			<td><p-dropdown class="w-100" [options]="sitePriorities" [(ngModel)]="property.sitePriority" optionLabel="name" appendTo="body"
				optionValue="value" (onChange)="formUpdate(property)" placeholder="Select Priority"></p-dropdown>
				</td>
			<td><span style="float:none">
					<a>
						<i class="pi pi-copy" aria-hidden="true" style="color:blue; font-size:110%; padding-right:20px;"
							(click)="onCopyToNewPropertyClick(property)"></i>
					</a>
					<a>
						<i class="pi pi-trash" aria-hidden="true" style="color:red; font-size:110%; cursor:pointer;"
							pTooltip="Delete Property" (click)="onDeletePropertyClick($event, property)"></i>
					</a>
				</span>
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} -
			{{recordTotal> 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows +
				lazyLoadEvent.first) : recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>

